/**
* グリッド位置指定 スタイル文字列生成
* @param {Number} r - 行位置
* @param {Number} c - 列位置
*/
export function GridPosStyle (r, c) {
  return {gridRow: r, msGridRow: r, gridColumn: c, msGridColumn: c}
}

/**
* グリッド位置指定 (列方向結合)
* @param {Number} r - 行位置
* @param {Number} c - 列位置
* @param {Number} cs - 結合する列数
*/
export function GridPosStyleWithColspan (r, c, cs) {
  return {gridRow: r, msGridRow: r, gridColumn: c + '/ span ' + cs, msGridColumn: c, msGridColumnSpan: cs}
}

/**
* CSSグリッドレイアウトのカラム定義
* @param {String} s - カラム定義
*/
export function GridColumns (s) {
  return {gridTemplateColumns: s, msGridColumns: s}
}



// WEBPACK FOOTER //
// ./src/GridUtils.js